module.exports = __webpack_public_path__ + "static/main-img-bg@2x-f5fb1f62f9a75918e495eeec35cac636.png";